export default __webpack_public_path__ + "static/media/vision.bc08d945.png";